import client from '../../ConnectionManager/apolloClient';
import { learnerDocumentById } from './query/learnerDocument.gql';

export const getLearnerDocument = async ({ documentId }) => {
  const result = await client.query({
    query: learnerDocumentById,
    variables: { documentId },
    errorPolicy: 'ignore',
    fetchPolicy: 'network-only',
  });
  return result;
};

export default { getLearnerDocument };
